<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Arrival/Departure List</h3>
        <div class="text-xs-right">
          <v-btn v-if="$oauth.checkIfHasPermission(['bulk arrival-departure-cancellation'])"
                 color="error"
                 title="Bulk Departure Cancel"
                 @click="bulkCancelModal= true"
                 dark
                 dense
                 fab
                 v-on="on"
                 x-small
          >
            <v-icon small>mdi-alpha-c-box</v-icon>
          </v-btn>
          <export-button
              class="ml-2"
              v-if="$oauth.checkIfHasPermission(['export arrival-departure-cancellation'])"/>
          <refresh-button :click-function="refreshData"></refresh-button>
        </div>
      </v-flex>
      <v-flex lg12>
        <v-card>
          <v-layout class="py-2 mx-2" row wrap>

            <v-flex class="pb-0" xs3>
              <v-text-field
                  :elevation="0"
                  class="hidden-sm-and-down "
                  flat
                  hide-details
                  placeholder="Search by typing here..."
                  prepend-inner-icon="search"
                  solo
                  v-model="filters.query"
                  @keypress.enter="handleFilterChange"
              ></v-text-field>
            </v-flex>
            <v-flex xs5 class="d-flex align-center">
              <custom-date-range-picker @change="handleFilterChange" v-model="filters.date_range"></custom-date-range-picker>
            </v-flex>
            <v-flex xs3>
              <v-autocomplete
                  :items="countries"
                  chips
                  clearable
                  deletable-chips
                  flat
                  hide-details
                  item-text="country_name"
                  item-value="id"
                  label="Country"
                  multiple
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="filters.country"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs3 class="pb-0">
              <v-text-field
                  class="hidden-sm-and-down"
                  flat
                  hide-details
                  placeholder="Document Number"
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="filters.document_number"
                  @input="handleFilterChange"
                  clearable
              ></v-text-field>
            </v-flex>
            <v-flex xs3 class="pb-0">
              <v-select
                  :items="ADTypes"
                  flat
                  solo
                  label="Filter By Type"
                  v-model="filters.type"
                  @input="handleFilterChange"
                  clearable
                  hide-details
                  prepend-inner-icon="filter_list"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
                :headers="headers"
                :items="all"
                :loading="loading"
                :options.sync="pagination"
                :footer-props="footerProps"
                :server-items-length="totalNumber"
                class="elevation-1"
                item-key="id"
                v-if="$oauth.checkIfHasPermission(['read arrived-report'])">

              <template v-slot:item.action="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on }" v-if="item.submission_no">
                    <v-btn
                        class="mr-2"
                        color="primary"
                        dark
                        dense
                        fab
                        v-on="on"
                        :href="'/system/visa-requests/view/'+item.submission_no"
                        :to="'/system/visa-requests/view/'+item.submission_no"
                        x-small>
                      <v-icon small>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>View Visa</span>
                </v-tooltip>
                <v-tooltip top v-if="$oauth.checkIfHasPermission(['read traveller-history'])">
                  <template v-slot:activator="{ on }">
                    <v-btn
                        class="mr-2"
                        color="primary"
                        dark
                        dense
                        fab
                        v-on="on"
                        :href="'/system/travellers-history/view/'+item.traveller"
                        :to="'/system/travellers-history/view/'+item.traveller"
                        x-small>
                      <v-icon small>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>View Traveller</span>
                </v-tooltip>
                <v-tooltip top
                           v-if="$oauth.checkIfHasPermission(['alter arrival-departure-cancellation']) && (item.type === 'Arrived' || item.type ==='Departed')">
                  <template v-slot:activator="{ on }">
                    <v-btn
                        @click="cancel(item)"
                        class="mr-2"
                        color="error"
                        dark
                        dense
                        fab
                        v-on="on"
                        x-small
                    >
                      <v-icon small>mdi-alpha-c-box</v-icon>
                    </v-btn>
                  </template>
                  <span>Cancel</span>
                </v-tooltip>
                <v-tooltip top
                           v-else-if="$oauth.checkIfHasPermission(['alter arrival-departure-cancellation']) && (item.type === 'Arrival cancelled' || item.type ==='Departure cancelled')">
                  <template v-slot:activator="{ on }">
                    <v-btn
                        @click="cancel(item)"
                        class="mr-2"
                        color="error"
                        dark
                        dense
                        fab
                        v-on="on"
                        x-small
                    >
                      <v-icon small>mdi-cancel</v-icon>
                    </v-btn>
                  </template>
                  <span>Re-Cancel</span>
                </v-tooltip>
                <v-tooltip top
                           v-if="$oauth.checkIfHasPermission(['alter arrival-departure-cancellation']) && (item.type === 'Departed' || item.type === 'Offload')">
                  <template v-slot:activator="{ on }">
                    <v-btn
                        @click="offload(item)"
                        class="mr-2"
                        color="error"
                        dark
                        dense
                        fab
                        v-on="on"
                        x-small
                    >
                      <v-icon small>mdi-airplane{{ item.type === 'Departed' ? '-off' : '' }}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ item.type === 'Departed' ? 'offload' : 'offload-cancel' }}</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>

        <v-dialog persistent v-model="cancelModal" width="500">
          <v-card>
            <v-card-title class="headline red lighten-1 white--text" default-title>
              {{
                (cancelForm.type === 'Arrival cancelled' || cancelForm.type === 'Departure cancelled') ? 'Re ' : ''
              }}Cancel
              Arrival/Departure
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <form-error-display-handler :errors="errors"></form-error-display-handler>
                  <v-flex xs12>
                    <v-form ref="cancelForm" v-model="valid" lazy-validation class="pa-2">
                      <v-textarea
                          label="Remarks/Reason"
                          :rules="[rules.required]"
                          outlined
                          v-model="cancelForm.remarks"
                      ></v-textarea>
                      <multiple-file-upload
                          label="Remarks file"
                          v-model="cancelForm.files"
                      ></multiple-file-upload>
                    </v-form>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red lighten-1"
                  class="white--text"
                  @click="cancelForm={};cancelModal =false;"
              >Close
              </v-btn>
              <v-btn color="blue darken-3" :loading="load" class="white--text" @click="cancelArrivalDeparture">
                Confirm
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog persistent v-model="bulkCancelModal" width="500">
          <v-card>
            <v-card-title class="headline red lighten-1 white--text" default-title>
              Bulk Departure Cancel
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <form-error-display-handler :errors="errors"></form-error-display-handler>
                  <v-flex xs12>
                    <v-form ref="cancelForm" v-model="valid" lazy-validation class="pa-2">
                      <v-flex xs12>
                        <v-autocomplete
                            :clearable="true"
                            :items="flight_numbers"
                            :rules="[rules.required]"
                            item-text="flight_number"
                            item-value="flight_number"
                            label="Flight Number *"
                            outlined
                            v-model="cancelForm.flight_bus_number"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12>
                        <v-menu
                            ref="menu"
                            v-model="startDateMenu"
                            :close-on-content-click="false"
                            :return-value.sync="cancelForm.departure_date"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="cancelForm.departure_date"
                                label="Departure Date *"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                              v-model="cancelForm.departure_date"
                              :rules="[rules.required]"
                              :max="todayDate"
                              no-title
                              scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="startDateMenu = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs.menu.save(cancelForm.departure_date)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-textarea
                          label="Remarks/Reason"
                          :rules="[rules.required]"
                          outlined
                          v-model="cancelForm.remarks"
                      ></v-textarea>
                      <multiple-file-upload
                          label="Remarks file"
                          v-model="cancelForm.files"
                      ></multiple-file-upload>
                    </v-form>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red lighten-1"
                  class="white--text"
                  @click="cancelForm={};bulkCancelModal =false;"
              >Close
              </v-btn>
              <v-btn color="blue darken-3" :loading="load" class="white--text" @click="cancelBulkArrivalDeparture">
                Confirm
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog persistent v-model="offloadModal" width="500">
          <v-card>
            <v-card-title class="headline red lighten-1 white--text" default-title>
              {{ (cancelForm.type === 'Departed') ? 'Offload' : 'Cancel Offload' }}
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <form-error-display-handler :errors="errors"></form-error-display-handler>
                  <v-flex xs12>
                    <v-form ref="cancelForm" v-model="valid" lazy-validation class="pa-2">
                      <v-textarea
                          label="Remarks/Reason"
                          :rules="[rules.required]"
                          outlined
                          v-model="cancelForm.remarks"
                      ></v-textarea>
                      <multiple-file-upload
                          label="Remarks file"
                          v-model="cancelForm.files"
                      ></multiple-file-upload>
                    </v-form>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red lighten-1"
                  class="white--text"
                  @click="cancelForm={};offloadModal =false;"
              >Close
              </v-btn>
              <v-btn color="blue darken-3" :loading="load" class="white--text" @click="offloadConfirm">
                Confirm
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Http from "axios";
import {API_URL, VERSION, VERSIONED_API_URL} from "../../config/config.js";
import {mapActions} from 'vuex';
import {commonListMixin} from "../../mixins/commonListMixin";
import {validationMixin} from "../../mixins/validationMixin";
import FormErrorDisplayHandler from "../../components/FormErrorDisplayHandler";
import FileInput from "../../components/FileInput";
import MultipleFileUpload from "../../components/MultipleFileUpload";
import RefreshButton from "@/components/RefreshButton";
import moment from "moment";
import CustomDateRangePicker from "../../components/CustomDateRangePicker.vue";

export default {
  name: "ArrivalDepartCancel",
  data() {
    return {
      startDateMenu: false,
      ADTypes: [
        "Arrival",
        "Departure",
        "Offload",
      ],
      headers: [
        {
          text: "S.N.",
          value: "s_no",
          sortable: false
        },
        {
          text: "Document Number",
          value: "document_number",
          sortable: false
        },
        {
          text: "Full Name",
          value: "full_name",
          sortable: false
        },
        {
          text: "Type",
          value: "type",
          sortable: false
        },
        {
          text: "Country",
          value: "country",
          sortable: false
        },
        {
          text: "Arrived from/Departed to",
          value: "origin_country",
          sortable: false
        },
        {
          text: "Time",
          value: "created_at",
          sortable: false
        },
        {
          text: "Latest status",
          value: "latest_status",
          sortable: false
        },
        {
          text: "Actions",
          value: "action",
          sortable: false
        },
      ],
      valid: true,
      cancelForm: {},
      errors: [],
      load: false,
      cancelModal: false,
      bulkCancelModal: false,
      offloadModal: false,
      todayDate: moment().format('Y-MM-DD'),
      pagination: {
        itemsPerPage: 25,
        sortBy: ['created_at'],
        sortDesc: ['true']
      },
      flight_numbers: []
    };
  },
  mixins: [commonListMixin, validationMixin],
  components: {CustomDateRangePicker, RefreshButton, FormErrorDisplayHandler, FileInput, MultipleFileUpload},
  computed: {
    all() {
      return this.$store.state.CommonList.all;
    },
    countries() {
      return this.$store.state.CountryList.all;
    }
  },
  methods: {
    ...mapActions({
      fetchCountries: "CountryList/fetchAllCountries"
    }),
    cancelBulkArrivalDeparture() {
      if (this.$refs.cancelForm.validate()) {
        this.load = true;
        let formData = new FormData();
        formData.set('remarks', this.cancelForm.remarks);
        formData.set('documents', this.cancelForm.files);
        formData.set('flight_bus_number', this.cancelForm.flight_bus_number);
        formData.set('departure_date', this.cancelForm.departure_date);
        let files = this.cancelForm.files;
        if (files)
          for (let i = 0; i < files.length; i++) {
            formData.append(`documents[${i}]`, files[i]);
          }
        Http.post(API_URL + VERSION + '/arrival-departure-cancellation/bulkCancel', formData)
            .then(res => {
              this.form = false;
              this.cancelForm = {};
              this.errors = null;
              this.bulkCancelModal = false;
              this.load = false;
              this.$store.commit("Notification/showSuccess", 'Departure Successfully Cancelled In Bulk !');
              this.getAll();
            })
            .catch(error => {
              this.load = false;
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
              }
              this.$store.commit("Notification/showError", error.response.data.message);
            });
      } else {
        this.$store.commit("Notification/showError", "Invalid Form Data");
      }
    }
    ,
    cancel(item) {
      this.cancelModal = true;
      this.cancelForm.track_id = item.id;
      this.cancelForm.type = item.type;
      this.cancelForm.country = item.origin_country;
      this.cancelForm.source = item.source;
    }
    ,
    offload(item) {
      this.offloadModal = true;
      this.cancelForm.track_id = item.id;
      this.cancelForm.type = item.type;
      this.cancelForm.country = item.origin_country;
    }
    ,
    offloadConfirm() {
      if (this.$refs.cancelForm.validate()) {
        this.load = true;
        let formData = new FormData();
        formData.set('track_id', this.cancelForm.track_id);
        formData.set('remarks', this.cancelForm.remarks);
        formData.set('documents', this.cancelForm.files);
        formData.set('country', this.cancelForm.country);
        let files = this.cancelForm.files;
        if (files)
          for (let i = 0; i < files.length; i++) {
            formData.append(`documents[${i}]`, files[i]);
          }
        if (this.cancelForm.type === 'Departed')
          Http.post(API_URL + VERSION + '/arrival-departure-cancellation/offload', formData)
              .then(res => {
                this.form = false;
                this.cancelForm = {};
                this.errors = null;
                this.offloadModal = false;
                this.load = false;
                this.$store.commit("Notification/showSuccess", 'Visa Offloaded!!');
                this.getAll();
              })
              .catch(error => {
                this.load = false;
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                }
                this.$store.commit("Notification/showError", error.response.data.message);
              });
        else
          Http.post(API_URL + VERSION + '/arrival-departure-cancellation/offload-cancel', formData)
              .then(res => {
                this.form = false;
                this.cancelForm = {};
                this.errors = null;
                this.offloadModal = false;
                this.load = false;
                this.$store.commit("Notification/showSuccess", 'Visa Offload-cancel!!');
                this.getAll();
              })
              .catch(error => {
                this.load = false;
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                }
                this.$store.commit("Notification/showError", error.response.data.message);
              });
      } else {
        this.$store.commit("Notification/showError", "Invalid Form Data");
      }
    }
    ,
    cancelArrivalDeparture() {
      // this.rejectModal = false;
      if (this.$refs.cancelForm.validate()) {
        this.load = true;
        let formData = new FormData();
        formData.set('track_id', this.cancelForm.track_id);
        formData.set('remarks', this.cancelForm.remarks);
        formData.set('documents', this.cancelForm.files);
        formData.set('country', this.cancelForm.country);
        formData.set('source', this.cancelForm.source);
        let files = this.cancelForm.files;
        if (files)
          for (let i = 0; i < files.length; i++) {
            formData.append(`documents[${i}]`, files[i]);
          }
        if (this.cancelForm.type === 'Arrived' || this.cancelForm.type === 'Departed')
          Http.post(API_URL + VERSION + '/arrival-departure-cancellation/cancel', formData)
              .then(res => {
                this.form = false;
                this.cancelForm = {};
                this.errors = null;
                this.cancelModal = false;
                this.load = false;
                this.$store.commit("Notification/showSuccess", 'Arrival/Departure Cancelled!!');
                this.getAll();
              })
              .catch(error => {
                this.load = false;
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                }
                this.$store.commit("Notification/showError", error.response.data.message);
              });
        else
          Http.post(API_URL + VERSION + '/arrival-departure-cancellation/re-cancel', formData)
              .then(res => {
                this.form = false;
                this.cancelForm = {};
                this.errors = null;
                this.cancelModal = false;
                this.load = false;
                this.$store.commit("Notification/showSuccess", 'Arrival/Departure Re-Cancelled!!');
                this.getAll();
              })
              .catch(error => {
                this.load = false;
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                }
                this.$store.commit("Notification/showError", error.response.data.message);
              });
      } else {
        this.$store.commit("Notification/showError", "Invalid Form Data");
      }
    }
    ,
    refreshData() {
      this.getAll();
    }
    ,
    getAllFlightNumbers() {
      Http.get(VERSIONED_API_URL + '/flight-numbers-all').then(r => {
        this.flight_numbers = r.data.data;
      })
    }
    ,
  },
  mounted() {
    let date = new Date();
    this.filters.date_range = {
      start: new Date(date).toISOString().substr(0, 10),
      end: new Date(date).toISOString().substr(0, 10),
    };
    this.getAllFlightNumbers()

    this.$store.commit("CommonList/setModel", "arrival-departure-cancellation");
    this.fetchCountries();
  }
}
</script>
